import styled from '@emotion/styled';
import { Tabs } from 'antd';
import { useState } from 'react';
import { TitreEntity } from '../../../../entities/titre.entity';
import { PRIMARY } from '../../../../shared/colors';
import { Orders } from './components/orders';
import { Transactions } from './components/transactions';

const Container = styled.div`
  height: 100%;
  color: var(--mt-text);

  > .content {
    font-family: Poppins-R;
    height: 100%;
  }

  .ant-tabs,
  .ant-tabs-content,
  .ant-tabs-tabpane {
    height: 100%;
  }

  .ant-tabs-nav {
    margin-bottom: 0;
    border-radius: 8px 8px 0 0;
    background:
      linear-gradient(135deg, rgba(255, 79, 31, 0.16), transparent 42%),
      ${PRIMARY};
  }

  .ant-tabs-tab {
    padding: 8px 12px;
    color: rgba(255, 255, 255, 0.78);
  }

  .activity-label {
    margin-left: 10px;
    color: var(--mt-warning);
    font-family: Poppins-B;
    text-transform: uppercase;
  }

  .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
    color: var(--mt-warning);
  }
`;

export const Activity = ({
  orders,
  transactions,
  getSelectedTitre,
  updateOders,
}: {
  orders: any[];
  transactions: any[];
  getSelectedTitre: (titre: TitreEntity) => void;
  updateOders: () => void;
}) => {
  const [tabIndex, setTabIndex] = useState('1');
  return (
    <Container>
      <div className='content'>
        <Tabs
          defaultActiveKey='1'
          activeKey={tabIndex}
          type='line'
          onChange={(key: string) => setTabIndex(key)}
          size='small'
          tabBarStyle={{ margin: 0 }}
        >
          <Tabs.TabPane
            tab={<span className='activity-label'>Activité</span>}
            key='0'
            disabled
          >
            <p>ACTIVITE</p>
          </Tabs.TabPane>
          <Tabs.TabPane tab='Ordres' key='1'>
            <Orders
              orders={orders}
              updateOders={updateOders}
              getSelectedTitre={getSelectedTitre}
            />
          </Tabs.TabPane>
          <Tabs.TabPane tab='Transactions' key='2'>
            <Transactions transactions={transactions} />
          </Tabs.TabPane>
          {/* <Tabs.TabPane tab='Récapitulatif' key='3'>
            <Summary orders={orders} transactions={transactions} />
          </Tabs.TabPane> */}
        </Tabs>
      </div>
    </Container>
  );
};
